import { Box } from "@mui/material";
import DOMPurify from "dompurify";
import { useSelector } from "react-redux";
import { IState } from "../../redux/reducers/rootReducers";
import { addTargetBlankToLinks } from "../../pages/new-ticket/SendEmailPopup";

interface EmailViewerProps {
    body: string;
    height?: number | string;
}

function EmailViewer({ body, height = 500 }: EmailViewerProps) {
    let sanitizedBody = DOMPurify.sanitize(body);
    sanitizedBody = addTargetBlankToLinks(sanitizedBody);
    const isDarkmode = useSelector((state: IState) => state.theme.theme);
    const styledBody = injectStyle(sanitizedBody, isDarkmode ? "dark-mode" : "");
    return (
        <Box>
            <iframe
                src={`data:text/html;charset=utf-8,${encodeURIComponent(styledBody)}`}
                width="100%"
                height={height}
                title="Sanitized Email Preview"
                style={{ border: "none" }}
            />
        </Box>
    );
}





const injectStyle = (html: string,className=""): string => {
    const customCSS = `
    .dark-mode.Email-Body * {
        color: #fff !important;
        background: unset !important;
    }`;

  const fullHTML = `
    <!DOCTYPE html>
    <html class="Email-Body ${className}">
      <head>
        <meta charset="UTF-8" />
        <style>${customCSS}</style>
      <head>
      <body>
        ${DOMPurify.sanitize(html)}
      </body>
    </html>
  `;
  return fullHTML;
};



export default EmailViewer;